import VenuesProxy from '@/proxies/Venues';
import VenuesTransform from '@/transforms/Venues';
import * as types from './mutation-types';

export default {
  async getItems({ commit, dispatch, getters }) {
    commit(types.LOADING, true);
    const proxy = new VenuesProxy();
    try {
      const response = await proxy.getVenues(getters.sort);
      commit(types.VENUES, VenuesTransform.fetchCollection(response.venues));
      commit(types.MORE, response.total > getters.items.length);
      commit(types.TOTAL, response.total);
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_get_venues', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async getItem({ commit, dispatch }, payload) {
    const proxy = new VenuesProxy();
    try {
      const response = await proxy.find(payload);
      commit(types.VENUE, VenuesTransform.fetch(response.venue));
    } catch (e) {
      dispatch('notification/error', ['errormessage.failed_to_get_venue', {venue_id: payload.id }], { root: true });
    }
  },
  addVenue({ commit }, payload) {
    commit(types.VENUES, [payload]);
  },
  async deleteItem({ commit, state }, payload) {
    const proxy = new VenuesProxy();
    try {
      await proxy.delete(payload);
      commit(types.DELETE, payload);
      const deletionCount = Array.isArray(payload) ? payload.length : 1;
      commit(types.TOTAL, state.total - deletionCount);
    } catch (e) {
      // TODO
    }
  },
  async create({ commit, dispatch }, payload) {
    commit(types.LOADING, true);
    const proxy = new VenuesProxy();
    try {
      const { afterAction, ...options } = payload;
      await proxy.create(options);
      await dispatch('refresh');
      afterAction();
      dispatch('notification/success', 'confirmationmessage.stadium_created', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_add_venue', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  async update({ commit, dispatch }, payload) {
    commit(types.LOADING, true);
    const proxy = new VenuesProxy();
    try {
      const { id, ...options } = payload;
      const response = await proxy.update(id, options);
      dispatch('refreshLocally', response);
      dispatch('notification/success', 'confirmationmessage.stadium_updated', { root: true });
    } catch (e) {
      dispatch('notification/error', 'errormessage.failed_to_update_venue', { root: true });
    } finally {
      commit(types.LOADING, false);
    }
  },
  sortItems({ commit, dispatch }, payload) {
    commit(types.SORT, payload);
    dispatch('getItems');
  },
  clearItems({ commit }) {
    commit(types.CLEAR_ITEMS);
  },
  resetFilter({ commit, dispatch, getters }) {
    commit(types.RESET_FILTER);
    dispatch('sortItems', getters.defaultSort);
  },
  async refresh({ commit, getters }) {
    const proxy = new VenuesProxy();
    try {
      const response = await proxy.getVenues({ ...getters.sort, ...{ page: 1, limit: getters.items.length } });
      commit(types.VENUES, VenuesTransform.fetchCollection(response.venues));
    } catch (e) {
      // TODO
    }
  },
  refreshLocally({ commit, dispatch, getters }, payload) {
    try {
      const result = getters.items.map(el => {
        if (el.id === payload._id) {
          return VenuesTransform.fetch(payload);
        }
        return el;
      });
      commit(types.VENUES, result);
    } catch {
      dispatch('refresh');
    }
  },
};
